// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label[data-v-3bb5277b]{font-size:17px;font-weight:700}.label-form[data-v-3bb5277b]{padding-left:141px}.tab-center[data-v-3bb5277b] .el-tabs__nav-wrap:after{background:#f0f0f0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
